export default {
  accountMenu: {
    changeEnvironment: 'Change Environment',
    account: 'Account',
    signIn: 'Sign in',
    signOut: 'Sign out',
    getSupport: 'Get Support',
    settings: 'Settings',
    language: 'Language',
    profile: 'My profile'
  },
  common: {
    search: 'Search',
    close: 'Close',
    loading: 'Loading',
    save: 'Save',
    cancel: 'Cancel',
    edit: 'Edit',
    delete: 'Delete',
    add: 'Add',
    yes: 'Yes',
    no: 'No',
    ok: 'Ok',
    confirm: 'Confirm',
    back: 'Back',
    next: 'Next',
    finish: 'Finish',
    apply: 'Apply',
    reset: 'Reset',
    refresh: 'Refresh',
    retry: 'Retry',
    settings: 'Settings',
    submit: 'Submit',
    more: 'More',
    moreActions: 'More actions',
    collapsedCrumbs: 'Show all breadcrumbs',
    editTitle: 'Edit title',
    showMore: '+ {n} more',
    showLess: '- show less',
    select: 'Select',
    multiplePaths: '{n} paths',
    alternatePaths: 'Alternate paths',
    copy: 'Copy',
    copyTo: 'Copy to',
    duplicate: 'Duplicate',
    moveLeft: 'Move left',
    moveRight: 'Move right',
    scanQRCode: 'Scan QR Code',
    sendRequest: 'Send request',
    discard: 'Discard',
    unsavedChangesTitle: 'Discard unsaved changes?',
    unsavedChangesMessage: 'You have unsaved changes that will be lost if you leave this page.'
  },
  admin: {
    settings: 'Settings',
    dataImport: {
      preserveIds: 'Preserve IDs',
      preserveIdsDetails:
        'Keep twin and relationship IDs from the import file. Existing twins with matching IDs will be updated.'
    },
    catalog: {
      title: 'Data catalog'
    },
    dataSources: {
      title: 'Data sources',
      add: 'Add data source',
      empty: 'No data sources have been added to this environment.'
    },
    environment: {
      tabs: {
        general: 'General',
        deployment: 'Deployment',
        apiKeys: 'API keys',
        secrets: 'Secrets',
        certificates: 'Certificates',
        jobs: 'Jobs',
        configuration: 'Configuration'
      },
      backupRestore: {
        title: 'Restore Backup',
        description:
          'Select an environment or upload a backup file (.ndjson). The backup will be imported into the current environment.',
        sourceCurrentEnv: 'This environment',
        sourceOtherEnv: 'Another environment',
        sourceFile: 'From backup file',
        environmentLabel: 'Environment',
        versionTimestamp: 'Timestamp',
        versionSize: 'Size',
        versionCurrent: 'Current',
        restoreAction: 'Restore',
        downloadAction: 'Download',
        noVersions: 'No backup versions available',
        selectVersionHint: 'Select a version to restore',
        fileDropLabel: 'Click or drag backup file here',
        fileDropHint: 'Accepted format: .ndjson',
        selectedFileLabel: 'Selected file:',
        backupFileLabel: 'Backup file:',
        outputFileLabel: 'Output file:',
        startRestore: 'Start Restore',
        invalidFileType: 'Please select a valid .ndjson backup file.',
        uploadFailed: 'Failed to upload backup file.',
        uploadSuccess: 'Backup file uploaded',
        copyUri: 'Copy URI',
        uriCopied: 'Backup URI copied to clipboard.',
        uriCopyFailed: 'Failed to copy backup URI.',
        triggerBackup: 'Trigger Backup',
        triggerHint: 'Manually trigger a backup of this environment.',
        backupTriggered: 'Backup triggered successfully.'
      },
      apiKeys: {
        title: 'API keys',
        newApiKey: 'New API key',
        update: 'Update',
        regenerate: 'Regenerate',
        share: 'Share',
        columns: {
          nameId: 'Name (Id)',
          secret: 'Secret',
          roles: 'Roles'
        },
        notify: {
          created: 'API key created successfully',
          updated: 'API key updated successfully',
          shared: 'API key shared successfully'
        },
        dialog: {
          regenerateTitle: 'Regenerate API key',
          regenerateConfirm: 'Are you sure you want to regenerate this API key?',
          deleteTitle: 'Delete API key',
          deleteConfirm: 'Are you sure you want to delete this API key?'
        }
      },
      secrets: {
        title: 'Secrets',
        newSecret: 'New Secret',
        share: 'Share',
        columns: {
          nameId: 'Name (Id)',
          secretType: 'Type',
          secret: 'Secret'
        },
        notify: {
          created: 'Secret created successfully',
          shared: 'Secret shared successfully'
        },
        dialog: {
          deleteTitle: 'Delete secret',
          deleteConfirm: 'Are you sure you want to delete this secret?'
        }
      },
      certificates: {
        title: 'Certificates',
        newCertificate: 'New Certificate',
        downloadPem: 'Download (PEM)',
        downloadPfx: 'Download (PFX)',
        update: 'Update',
        regenerate: 'Regenerate',
        columns: {
          nameId: 'Name (Id)',
          expiry: 'Expiry',
          thumbprint: 'Thumbprint'
        },
        notify: {
          created: 'Certificate created successfully',
          updated: 'Certificate updated successfully'
        },
        dialog: {
          regenerateTitle: 'Regenerate certificate',
          regenerateConfirm: 'Are you sure you want to regenerate this self-signed certificate?',
          deleteTitle: 'Delete certificate',
          deleteConfirm: 'Are you sure you want to delete this self-signed certificate?'
        }
      },
      jobs: {
        downloadInput: 'Download input',
        downloadOutput: 'Download output',
        downloadFailed: 'Failed to download file'
      }
    },
    devices: {
      onboarding: {
        eventGridInstance: 'Event Grid instance',
        eventGridHint:
          'Select the Event Grid MQTT broker for this device (default uses the deployment broker)',
        eventGridDefault: 'Default (automatic)',
        eventGridInvalid: 'Select a valid Event Grid instance'
      }
    },
    models: {
      title: 'Data models',
      loadFromRepo: 'Load from repo',
      upload: 'Upload',
      new: 'New',
      newModel: 'New Model',
      extend: 'Extend',
      deleteAll: 'Delete all',
      export: 'Export',
      filter: 'Filter',
      view: 'View',
      decommission: 'Decommission',
      selectModelHint: 'Select a model to view its definition',
      addModels: 'Add models',
      addSuccess: '{count} model(s) added',
      errors: {
        empty: 'Paste one or more DTDL models before saving.',
        invalidJson: 'The content is not valid JSON.',
        addFailed: 'The models could not be added.',
        refreshFailed: 'The models were added, but the list could not be refreshed.'
      },
      dialog: {
        decommissionTitle: 'Decommission selected model',
        decommissionSingleConfirm: 'Are you sure you want to decommission this model? {models}',
        decommissionMultipleConfirm:
          'Are you sure you want to decommission all these models? {models}',
        deleteSingleTitle: 'Delete selected model',
        deleteMultipleTitle: 'Delete all selected models',
        deleteSingleConfirm:
          'Are you sure you want to delete the selected model and the dependencies? {models}',
        deleteMultipleConfirm:
          'Are you sure you want to delete all selected models and their dependencies? {models}',
        deleteAllTitle: 'Delete all models',
        deleteAllConfirm: 'Are you sure you want to delete all models?'
      }
    },
    users: {
      newUsers: 'New users',
      exportRoles: 'Export roles',
      importRoles: 'Import roles',
      filter: 'Filter',
      addRole: 'Add role',
      deleteRole: 'Delete role',
      setKqlRole: 'Set KQL Database role',
      deleteKqlRole: 'Delete KQL Database role',
      columns: {
        nameId: 'Name (Id)',
        email: 'Email',
        status: 'Status',
        roles: 'Roles'
      },
      tabs: {
        all: 'All users',
        registered: 'Registered',
        pending: 'Pending'
      },
      status: {
        registered: 'Registered',
        pending: 'Pending'
      },
      dialog: {
        deleteRoleTitle: 'Delete role',
        deleteRoleMessage: 'Are you sure you want to delete the role "{role}" from {user}?',
        deleteAdxRoleTitle: 'Delete ADX role',
        deleteAdxRoleMessage: 'Are you sure you want to delete this ADX user role assignment?'
      },
      notify: {
        roleAdded: 'Role {role} added to user {user}',
        roleAddFailed: 'Failed to add role {role} to user {user}',
        roleDeleted: 'Role {role} deleted from user {user}',
        roleDeleteFailed: 'Failed to delete role {role} from user {user}',
        adxRoleAssigned: 'Role {role} assigned to user {user} in KQL Database',
        adxRoleAssignFailed: 'Failed to assign role {role} to user {user} in KQL Database',
        adxRoleDeleted: 'Role {role} deleted from user {user} in KQL Database',
        adxRoleDeleteFailed: 'Failed to delete role {role} from user {user} in KQL Database',
        addUsersFailed: 'Failed to add {count} user roles',
        addUsersSuccess: 'Added {count} user roles',
        adxRolesFailed: 'Failed to get ADX roles for users'
      }
    },
    features: {
      filter: 'Filter',
      editFeature: 'Edit feature',
      reorderFeatures: 'Reorder features',
      doneReordering: 'Done',
      reorderHint: 'Drag to reorder',
      orderNumber: 'Order {order}',
      reorderClearFilter: 'Clear the filter to reorder features',
      reorderFailed: 'Could not save the new feature order'
    },
    files: {
      upload: 'Upload file',
      download: 'Download file',
      preview: 'Preview file',
      noConfigurationProperties: 'No configuration properties found for this environment type.'
    }
  },
  relations: {
    editRelationship: 'Edit relationship',
    deleteRelationship: 'Delete relationship',
    deleteRelationshipConfirm: 'Are you sure you want to delete this relationship?'
  },
  files: {
    upload: 'Upload',
    linkAutodeskFile: 'Link Autodesk File',
    files: 'Files',
    contextMenu: {
      viewFile: 'View file',
      viewOnAcc: 'View file on ACC',
      downloadFile: 'Download file',
      fileVersions: 'File versions',
      uploadNewVersion: 'Upload new version',
      versionItem: 'v{version}: {date} by {name}'
    },
    uploadDialog: {
      titleImages: 'Upload images',
      titleFiles: 'Upload files',
      pickImages: 'Pick images',
      pickFiles: 'Pick files',
      submit: 'Upload'
    },
    uploadVersionDialog: {
      title: 'Upload new version',
      pickFile: 'Pick file',
      submit: 'Upload'
    },
    linkDialog: {
      title: 'Link Autodesk File',
      submit: 'Link'
    },
    linkOneLakeFile: 'Link OneLake File',
    linkOneLakeFileDialog: {
      title: 'Link OneLake File',
      submit: 'Link'
    }
  },
  flows: {
    shared: 'Shared',
    nonDurable: 'Non-Durable',
    disabled: 'Disabled',
    duplicate: 'Duplicate',
    export: 'Export',
    import: 'Import',
    enable: 'Enable',
    disable: 'Disable',
    share: 'Share',
    columns: {
      name: 'Name',
      lastRun: 'Last run',
      status: 'Status'
    },
    dialog: {
      deleteTitle: 'Delete flow',
      deleteConfirm: 'Are you sure you want to delete {name}?',
      deleteSelectedTitle: 'Delete selected flows',
      deleteSelectedConfirm: 'Are you sure you want to delete {count} flow(s)?',
      enableTitle: 'Enable selected flows',
      enableConfirm: 'Are you sure you want to enable all those flows ({count})?',
      disableTitle: 'Disable selected flows',
      disableConfirm: 'Are you sure you want to disable all those flows ({count})?'
    },
    importDialog: {
      title: 'Import flows',
      fileLabel: 'Flow file(s)',
      overwrite: 'Overwrite existing flows?',
      invalidFile: 'Invalid file'
    },
    copilot: {
      tabLabel: 'Copilot',
      welcomeTitle: 'Flow Config Copilot',
      welcomeSubtitle: 'I can help you configure and troubleshoot this flow'
    },
    clear: 'Clear',
    run: 'Run',
    runWithPayload: 'Run with payload',
    nothingSelected: 'Nothing selected',
    activitiesSelected: '{count} activity selected | {count} activities selected',
    relationshipsSelected: '{count} relationship selected | {count} relationships selected',
    layoutGraph: 'Layout graph',
    topToBottom: 'Top to Bottom',
    leftToRight: 'Left to Right',
    relayout: 'Re-layout',
    nonDurableExecution: 'Non-Durable Execution',
    nonDurableTooltip:
      'Non-Durable execution runs faster for small payloads, but is less resilient. Only recommended for short-running flows.',
    disabledTooltip: 'Disable the flow (prevents any new runs)',
    enableTooltip: 'Flow is disabled. Click to enable.',
    newFlow: 'New Flow',
    flowsLabel: 'Flows',
    tabs: {
      payloads: 'Payloads',
      activity: 'Activity',
      logs: 'Logs',
      runs: 'Runs'
    },
    notify: {
      saved: 'Flow saved',
      imported: 'Imported {count} flow(s)',
      shared: 'Flow shared successfully',
      flowCreated: 'Flow created',
      activityTriggered: 'Activity triggered',
      copiedToClipboard: 'Copied to clipboard',
      cutToClipboard: 'Cut to clipboard',
      invalidDataFormat: 'Invalid data format'
    }
  },
  languages: {
    en: 'English',
    fr: 'French',
    nl: 'Dutch'
  },
  history: {
    updatedBy: 'Updated by {user}'
  },
  viewer: {
    catalogBrowser: {
      title: 'Data catalog',
      open: 'Browse data catalog',
      sources: {
        title: 'Catalog sources',
        empty: 'No catalog sources are available.',
        smartAtlas: 'Smart Atlas',
        oneLake: 'OneLake',
        autodesk: 'Autodesk Construction Cloud'
      },
      collections: {
        title: 'Collections',
        empty: 'Nothing matched your search, or this source has no collections.',
        error: 'Collections could not be loaded.'
      },
      items: {
        title: 'Items',
        empty: 'Nothing matched your search, or this collection has no items.',
        error: 'Items could not be loaded.'
      },
      tree: {
        searching: 'Searching the tree…',
        searchLimited: 'Search covered only part of the tree. Expand a folder to search inside it.'
      },
      preview: {
        alt: 'Preview of {name}'
      },
      item: {
        modelUnavailable: 'Not available in this environment',
        source: 'Source',
        selectableVariants: 'Select variants'
      }
    },
    modelVersion: {
      title: 'Model version',
      version: 'Version',
      latestHint: 'Leave empty to load the latest version whenever the model opens.',
      viewable: 'Viewable',
      loadError: 'The model versions could not be loaded from Autodesk Construction Cloud.',
      currentVersionMissing:
        'The version this model uses is no longer in Autodesk Construction Cloud. Choose a version to continue.',
      saveError: 'The model version could not be saved.'
    },
    catalogLink: {
      configuration: {
        title: 'Layer configuration',
        modelTitle: 'Model configuration',
        back: 'Back to the catalog',
        variable: 'Variable',
        dimensionSelector: 'Dimension selector',
        layerCount: 'Will add {count} layer | Will add {count} layers',
        variantDimensionRequired: 'Choose at least one {dimension}.',
        variantLimit: 'Select at most {count} layer combinations at once.',
        variableRequired: 'Select a variable before adding this layer.',
        customizeStyling: 'Customize styling',
        partialCompletion:
          '{count} layer added before the failure. Retry continues with the remaining layers.'
      },
      submit: 'Add layer | Add {count} layers',
      submitModel: 'Add model'
    },
    label: {
      model: 'Model',
      map: 'Map'
    },
    menu: 'Menu',
    openModelOf: 'Open model of',
    openPanel: 'Layers',
    mapActionsLabel: 'Map actions',
    scrollZoomInteractionTooltip:
      'Toggle plain scroll zoom. When off, hold Ctrl (Cmd on Mac) while scrolling to zoom.',
    sourceOptions: {
      autodesk: {
        label: 'Link Autodesk Construction Cloud',
        description: 'Link an existing 3D or 2D model hosted on Autodesk Construction Cloud.'
      },
      spatialData: {
        label: 'Upload Spatial Data',
        description: 'Upload Spatial Data (GeoJSON, KML, KMZ, ...).'
      },
      tileLayer: {
        label: 'Link Tile Layer',
        description:
          'Link a hosted rastered image tile layer using a TileJSON source or a parametrized URL.'
      },
      vectorLayer: {
        label: 'Link Vector Layer',
        description: 'Link a hosted vector tile layer using a TileJSON source or parametrized URLs.'
      },
      esriFeatureServer: {
        label: 'Link ESRI Feature Server',
        description: 'Link a hosted ESRI Feature Server.'
      },
      smartAtlasProject: {
        label: 'Link Smart Atlas Project',
        description: 'Link an Arcadis Smart Atlas Project.'
      },
      geoTiff: {
        label: 'Upload GeoTIFF',
        description: 'Upload a Cloud Optimized GeoTIFF for dynamic tiling.'
      },
      oneLakeGeoTiff: {
        label: 'Link OneLake GeoTIFF',
        description: 'Link a Cloud Optimized GeoTIFF stored in OneLake for dynamic tiling.'
      },
      oneLakeSpatialData: {
        label: 'Link OneLake Spatial Data',
        description: 'Link spatial data (GeoJSON, KML, KMZ, ...) stored in OneLake.'
      },
      stac: {
        label: 'Link STAC Layer',
        description: 'Link a SpatioTemporal Asset Catalog (STAC) item for dynamic tiling.'
      },
      multidim: {
        label: 'Link Multidimensional Layer',
        description:
          'Link a multidimensional dataset (NetCDF, GRIB, Zarr, Kerchunk) for dynamic tiling.'
      },
      multidimUpload: {
        label: 'Upload Multidimensional File',
        description: 'Upload a NetCDF (.nc) file for multidimensional dynamic tiling.'
      }
    },
    stac: {
      stacUrlLabel: 'STAC URL',
      stacUrlHint: 'URL of the STAC item or collection.',
      variableLabel: 'Variable (asset key)',
      variableHint: 'Optional asset key within the STAC item to render.',
      variableDetecting: 'Detecting assets…',
      variableManualHint: 'Auto-detection failed. Enter asset key manually.',
      stacAssetsLabel: 'Asset keys (comma-separated)',
      stacAssetsHint: 'Optional comma-separated list of asset keys to include.',
      stacAssetsDetecting: 'Detecting assets…',
      stacAssetsManualHint: 'Auto-detection failed. Enter keys manually.',
      dimensionSelectorLabel: 'Dimension Selector',
      dimensionKeyLabel: 'Dimension',
      dimensionValueLabel: 'Value',
      addDimension: 'Add Dimension',
      styleLabel: 'Style',
      opacityLabel: 'Opacity',
      rescaleLabel: 'Rescale (min,max)',
      rescalePlaceholder: 'e.g. 0,1000',
      rescaleHint: 'Optional comma-separated min,max range for display scaling.',
      colorMapLabel: 'Named colormap',
      colorMapHint: 'Optional rio-tiler colormap. Leave empty to use RGB bands.'
    },
    multidim: {
      sourceUrlLabel: 'Source URL',
      sourceUrlHint: 'URL of the multidimensional dataset.',
      sourceFormatLabel: 'Source Format',
      sourceFormatHint: 'Format of the multidimensional dataset.',
      variableLabel: 'Variable',
      variableHint: 'Variable name to render.',
      variableDetecting: 'Detecting variables…',
      variableManualHint: 'Auto-detection failed. Enter variable name manually.',
      dimensionDetecting: 'Detecting dimensions…',
      dimensionAutoHint: 'Auto-detected from dataset. Adjust values as needed.',
      dimensionFillError: 'Failed to detect dimensions. Use the form below.',
      dimensionSelectorLabel: 'Dimension Selector',
      dimensionKeyLabel: 'Dimension',
      dimensionValueLabel: 'Value',
      addDimension: 'Add Dimension',
      styleLabel: 'Style',
      opacityLabel: 'Opacity',
      rescaleLabel: 'Rescale (min,max)',
      rescalePlaceholder: 'e.g. 0,1000',
      rescaleHint: 'Optional comma-separated min,max range for display scaling.',
      colorMapLabel: 'Named colormap',
      colorMapHint: 'Optional rio-tiler colormap. Leave empty to use RGB bands.'
    },
    multidimUpload: {
      fileLabel: 'Pick NetCDF file(s)',
      fileHint:
        'Supported formats: <code>.nc</code>, <code>.nc4</code>. You can upload multiple files — they will share the same configuration.',
      sourceFormatLabel: 'Source Format',
      variableLabel: 'Variable',
      variableHint: 'Variable name to render.',
      dimensionSelectorLabel: 'Dimension Selector',
      dimensionKeyLabel: 'Dimension',
      dimensionValueLabel: 'Value',
      addDimension: 'Add Dimension',
      styleLabel: 'Style',
      opacityLabel: 'Opacity',
      rescaleLabel: 'Rescale (min,max)',
      rescalePlaceholder: 'e.g. 0,1000',
      rescaleHint: 'Optional comma-separated min,max range for display scaling.',
      colorMapLabel: 'Named colormap',
      colorMapHint: 'Optional rio-tiler colormap. Leave empty to use default.'
    },
    oneLakeFile: {
      styleLabel: 'Style',
      opacityLabel: 'Opacity',
      rescaleLabel: 'Rescale (min,max)',
      rescalePlaceholder: 'e.g. 0,1000',
      rescaleHint: 'Optional comma-separated min,max range for display scaling.',
      colorMapLabel: 'Named colormap',
      colorMapHint: 'Optional rio-tiler colormap. Leave empty to use RGB bands.',
      hazardPaletteLabel: 'Nexus hazard palette',
      hazardPaletteHint:
        'Applies the exposure-gauge colours for a Nexus hazard. Designed for a 0–100 percentile with a 0,100 rescale.',
      hazardPalettes: {
        wind: 'Wind',
        wildfire: 'Wildfire',
        heat: 'Heat',
        cold: 'Cold',
        precipitation: 'Precipitation',
        flooding: 'Flooding',
        hail: 'Hail',
        drought: 'Drought',
        'global-risk': 'Global risk percentile'
      }
    },
    controls: {
      buildings3dShow: 'Show 3D buildings',
      buildings3dHide: 'Hide 3D buildings',
      trafficShow: 'Show traffic',
      trafficHide: 'Hide traffic',
      weatherShow: 'Show weather layer',
      weatherActive: '{type} weather layer active (click to hide)',
      weatherNone: 'None',
      weatherRadar: 'Radar',
      weatherInfrared: 'Infrared',
      demShow: 'Show terrain elevation (DEM)',
      demHide: 'Hide terrain elevation (DEM)'
    },
    detailsPanel: {
      title: 'Details',
      empty: 'Select an object on the map to see its details.'
    },
    legend: {
      title: 'Legend',
      noData: 'No data',
      minimize: 'Minimize legend',
      expand: 'Expand legend',
      loading: 'Loading legend…',
      loadError: 'Legend unavailable',
      filterHide: 'Filter this class out of the map',
      filterShow: 'Show this class on the map',
      filterReset: 'Show all classes'
    },
    graph: {
      empty: 'No twins to show. Browse or select a twin to see its relationship graph.',
      layout: 'Layout',
      layouts: {
        klay: 'Hierarchical',
        breadthfirst: 'Breadthfirst',
        circle: 'Circle',
        concentric: 'Concentric',
        cose: 'Force-directed',
        grid: 'Grid'
      },
      fetchIncoming: 'Fetch incoming {relationship}',
      fetchOutgoing: 'Fetch outgoing {relationship}',
      fetchIncomingAll: 'Fetch incoming connections',
      fetchOutgoingAll: 'Fetch outgoing connections'
    },
    viewerDataPanel: {
      title: 'Layers',
      filterPlaceholder: 'Filter layers',
      findLayerPlaceholder: 'Find a layer',
      source: 'Source: {source}',
      opacity: 'Opacity: {pct}%',
      ungrouped: 'Ungrouped',
      show: 'Show',
      hide: 'Hide',
      map: 'Map',
      threeD: '3D',
      graph: 'Graph',
      mapLayers: 'Map layers',
      groupCount: '{loaded} of {total} layers loaded',
      twinsLayer: 'Tile data',
      menu: {
        trigger: 'Manage layer'
      },
      samePanelLayout: {
        label: 'Same-side panel layout',
        tabs: 'Tabs (combined)',
        split: 'Split (separate panels)',
        description: 'How the layers and legend panels are arranged when they are on the same side.'
      }
    },
    alignment: {
      menuItem: 'Adjust model alignment',
      title: 'Align model',
      description:
        'Shift and scale the model so it lines up with the other layers. The alignment is stored on the model and applied on every load.',
      positionHeading: 'Position',
      rotationHeading: 'Rotation',
      offsetX: 'Offset X',
      offsetY: 'Offset Y',
      offsetZ: 'Offset Z',
      rotationX: 'Rotation X',
      rotationY: 'Rotation Y',
      rotationZ: 'Rotation Z',
      metres: 'm',
      degrees: '°',
      factor: '×',
      scale: 'Scale',
      scaleHint: '1 keeps the original size, 2 doubles it, 0.5 halves it',
      invalidScale: 'Scale must be greater than 0'
    },
    geoTiffStyling: {
      menuItem: 'Adjust layer style',
      title: 'Layer style',
      rasterHeading: 'Raster settings',
      rasterHint: 'Control the source zoom range and tile size.',
      tileMinSourceZoomLabel: 'Minimum source zoom',
      tileMaxSourceZoomLabel: 'Maximum source zoom',
      tileScaleLabel: 'Tile scale',
      tileScaleHint: '1 uses 256 x 256 pixel tiles.',
      suggestRescale: 'Suggest rescale from p2-p98 statistics',
      statisticsUnavailable: 'Statistics are not available for this layer.',
      statisticsError: 'Unable to suggest a rescale range.'
    }
  },
  formTile: {
    keyValueArray: {
      keyLabel: 'Key',
      value: 'Value',
      add: 'Add',
      edit: 'Edit',
      remove: 'Remove',
      confirm: 'Confirm',
      cancel: 'Cancel',
      empty: 'No entries yet.',
      duplicateKey: 'This key already exists.'
    }
  },
  dashboard: {
    toolbar: {
      new: 'New',
      more: 'More',
      newParameter: 'New parameter',
      newTile: 'New tile',
      configuration: 'Configuration',
      savePictures: 'Save pictures',
      saveLayout: 'Save layout',
      sharedQueries: 'Shared queries',
      print: 'Print',
      slider: 'Slider',
      rangeSlider: 'Range slider',
      openEditor: 'Dashboard editor'
    }
  },
  gaugeTile: {
    minimum: 'Min: {value}',
    maximum: 'Max: {value}'
  },
  treeTable: {
    name: 'Name',
    actions: 'Actions',
    columns: 'Columns',
    collapse: 'Collapse',
    collapseAll: 'Collapse all',
    expand: 'Expand',
    expandAll: 'Expand all',
    filter: 'Filter',
    goTo: 'Go to',
    groupBy: 'Group by',
    noData: 'No rows match the filters applied.',
    truncated:
      'More rows than can be drawn — {count} hidden. Collapse a branch, or group by a higher level.'
  },
  treeTableFeature: {
    title: 'Tree table',
    mode: 'View mode',
    browse: 'Browse',
    customQuery: 'Query',
    queryKind: 'Query type',
    execute: 'Execute',
    open: 'Open'
  },
  lazyExtension: {
    loadFailed: 'Part of this page could not be loaded. Try again.'
  },
  optionPicker: {
    select: 'Select…',
    loading: 'Loading…',
    empty: 'No options available',
    error: 'Options could not be loaded',
    clear: 'Clear',
    confirmTitle: 'Please confirm',
    confirmDefault: 'Do you want to continue?',
    confirm: 'Confirm',
    cancel: 'Cancel',
    failed: 'The action failed'
  },
  jetconnect: {
    assignPlaceholder: 'Assign POC…',
    floor: 'Floor {floor}',
    capacityLeft: '{amount} {unit} left after',
    capacityShort: 'Short by {amount} {unit}',
    distanceMetres: '{distance} m',
    distanceViewerUnits: '{distance} viewer units',
    distanceUnknown: 'Distance unknown',
    notInViewer: 'Not in the 3D model: assign manually',
    insufficientCapacity: 'Insufficient capacity',
    viewerLoading: 'Viewer loading…',
    pocsLoading: 'Loading POCs…',
    pocsError: 'POCs could not be loaded',
    rankError: 'POCs could not be ranked',
    noCandidates: 'No compatible POC for {serviceCode}',
    noCandidatesInRange: 'No compatible POC within {max} m',
    filterUncalibrated:
      'Distance filter not applied: the viewer distance is not calibrated to metres',
    writeFailed: 'Assignment failed: {reason}',
    noConnection: 'This row is not a connection',
    assigned: 'Assigned to {poc}',
    unassigned: 'Assignment removed',
    confirmOverCapacity:
      '{poc} does not have enough capacity left for this connection. Assign anyway? Its remaining capacity becomes negative.',
    autoAssign: {
      blocked: 'Not available yet: {reason}',
      button: 'Auto-assign',
      buttonBlocked: 'Auto-assign ({reason})',
      noTool: 'select a tool',
      dataLoading: 'loading data…',
      loadError: 'data could not be loaded',
      unavailable: 'Auto-assign is not available here',
      title: 'Auto-assign connections',
      scopeTool: 'Whole tool · unassigned connections: {count}',
      scopeSelection: 'Selection · unassigned connections: {count}',
      onlySelected: 'Only the selected connections ({count})',
      summary:
        '{assigned} to assign · {unassignable} cannot be assigned · {skipped} already assigned (skipped)',
      plannedTitle: 'Planned assignments',
      unassignableTitle: 'Cannot be assigned',
      nothing:
        'Nothing to assign: every connection in scope is already assigned or cannot be placed.',
      colConnection: 'Connection',
      colSystem: 'System',
      colRequired: 'Required',
      colCapacity: 'Capacity left',
      colReason: 'Reason',
      pocCapacity: '{before} → {after} {unit}',
      pocUsed: 'Connections: {count} · {used} {unit}',
      distanceUnknownNote:
        '{count} planned assignments use a POC whose distance is unknown; they are listed last.',
      confirm: 'Assign {count}',
      cancel: 'Cancel',
      close: 'Close',
      undo: 'Undo',
      undoCount: 'Undo {count}',
      progress: 'Assigning… {done} / {total}',
      undoProgress: 'Undoing… {done} / {total}',
      resultAssigned: 'Connections assigned: {count}',
      resultFailed: '{count} failed',
      resultAlready: '{count} were assigned in the meantime and left unchanged',
      tableRefresh: 'The table updates in a few seconds.',
      undone: 'Assignments undone: {count}',
      undoStateChanged: '{count} left unchanged because they changed since the run',
      undoFailed: '{count} could not be undone',
      failed: 'Auto-assign failed: {message}',
      reason: {
        'no-capacity': 'No POC of this system has enough capacity left',
        'no-matching-system': 'No POC exists for this system',
        'unit-mismatch': 'No POC of this system uses the same unit',
        'distance-unavailable': 'Only POCs with an unknown distance have capacity',
        'invalid-requirement': 'Required flow is missing or not a number'
      }
    }
  },
  table: {
    toolbar: {
      links: 'Links',
      import: 'Import',
      more: 'More',
      editQueries: 'Edit queries',
      newQuery: 'New',
      createNewFeatureQuery: 'Create new feature query',
      saveFeatureQueries: 'Save feature queries',
      queryAll: 'Query all',
      queryAllWithFilters: 'Query all with filters',
      newFolder: 'New folder',
      new: 'New',
      createNewTwin: 'Create new twin',
      addMultipleTwins: 'Add multiple twins',
      editTwin: 'Edit selected twin',
      editTwins: 'Edit selected twins',
      move: 'Move',
      moveTwin: 'Move selected twin',
      moveTwins: 'Move selected twins',
      duplicate: 'Duplicate',
      duplicateTwin: 'Duplicate selected twin',
      deleteTwin: 'Delete selected twin',
      deleteTwins: 'Delete selected twins',
      clear: 'Clear',
      clearSelection: 'Clear selection',
      addMarker: 'Add marker',
      addMarkerTooltip: 'Add marker in viewer',
      removeMarker: 'Remove marker',
      removeMarkerTooltip: 'Remove marker for selected twin in viewer',
      linkTwinToObject: 'Link twin to object',
      linkTwinToObjectTooltip: 'Link selected twin to object in viewer',
      removeLink: 'Remove link',
      removeLinkTooltip: 'Remove link between selected twin and viewer',
      linkTwinsByProperty: 'Link twins by property',
      linkTwinsByPropertyTooltip: 'Link twins to objects in viewer by property',
      removeLinksByProperty: 'Remove links by property',
      removeLinksByPropertyTooltip: 'Remove linked twins in viewer by property',
      updateTwinsByProperty: 'Update twins by property',
      updateTwinsByPropertyTooltip: 'Update existing linked twins with data from viewer',
      importFromFile: 'Import from file',
      importFromFileTooltip: 'Import twin data from a file (CSV, Excel, JSON, ...)',
      uploadFilesFromFolder: 'Upload files from folder',
      importSelectedObjectsOld: 'Import selected objects from viewer (old)',
      importAllObjectsOld: 'Import all objects from viewer (old)',
      importSelectedObjects: 'Import selected objects from viewer',
      importAllObjects: 'Import all objects from viewer',
      export: 'Export',
      restoreViewerState: 'Restore viewer state',
      saveViewerState: 'Save viewer state',
      uploadFiles: 'Upload files',
      linkAutodeskFile: 'Link Autodesk File',
      generateQRCode: 'Generate QR code',
      generateQRCodesBulk: 'Generate QR codes (bulk)'
    }
  },
  chat: {
    header: {
      toggle: 'Toggle AI Chat'
    },
    drawer: {
      title: 'AI Assistant',
      clearChat: 'New session',
      tryAsking: 'Try asking:',
      aiAssistantName: 'AI Assistant',
      errorOccurred: 'An error occurred. Please try again.',
      retry: 'Retry',
      typeMessage: 'Type a message...',
      sendMessage: 'Send message',
      stopGenerating: 'Stop generating',
      disclaimer: 'AI can make mistakes. Verify important information.',
      you: 'You',
      welcomeTitle: 'Digital Twins Assistant',
      climateRiskTitle: 'Climate Risk Assistant',
      welcomeSubtitle: 'I can help you explore and understand your digital twin data',
      climateRiskSubtitle: 'I can help you understand climate hazards and risk scores',
      envSuffix: ' in ',
      defaultSuggestion1: 'What can you help me with?',
      defaultSuggestion2: 'How do I query digital twins?',
      defaultSuggestion3: 'Show me the available data',
      climateRiskSuggestion1: 'How is the heat score calculated?',
      climateRiskSuggestion2: 'How are scores benchmarked?',
      climateRiskSuggestion3: 'What hazard metrics are used for coastal flooding?',
      modelLabel: 'Model',
      continueWithModel: 'Continue with another model'
    },
    toolCall: {
      executing: 'Executing...',
      error: 'Error',
      completed: 'Completed',
      awaitingApproval: 'Awaiting approval',
      rejected: 'Rejected',
      approvalReason: 'Optional rejection reason',
      approve: 'Approve',
      reject: 'Reject',
      input: 'Input',
      output: 'Output'
    },
    flowPreview: {
      title: 'Changes applied',
      activitiesChanged: '{count} activity changed | {count} activities changed',
      keep: 'Keep',
      undo: 'Undo'
    },
    tilePreview: {
      title: 'Tile preview',
      unsupported: 'Preview not available for {type}.',
      addToDashboard: 'Add to dashboard',
      addedToDashboard: 'Tile "{name}" added to dashboard.',
      addFailed: 'Failed to add tile to dashboard.',
      noDashboard: 'No dashboard is currently open.',
      openEditor: 'Open editor'
    },
    dashboardPreview: {
      title: 'Changes applied',
      tilesChanged: '{count} tile changed | {count} tiles changed',
      keep: 'Keep',
      undo: 'Undo'
    },
    sessions: {
      title: 'Conversation history',
      history: 'Conversation history',
      empty: 'No previous conversations',
      untitled: 'Untitled conversation',
      messageCount: '{count} message | {count} messages',
      loadError: 'Failed to load conversation',
      deleteError: 'Failed to delete conversation'
    },
    attachments: {
      attachFiles: 'Attach files',
      dropFiles: 'Drop files to attach',
      removeAttachment: 'Remove attachment'
    }
  },
  runtimeParameters: {
    malformedMultiValue: 'Parameter "{name}" has an invalid multiple-value selection.'
  },
  featureEditor: {
    title: 'Feature editor',
    preview: 'Preview',
    save: 'Save changes',
    discard: 'Discard',
    back: 'Back to feature',
    backToParent: 'Back to parent feature',
    unsavedChanges: 'Unsaved changes',
    saved: '{count} change saved | {count} changes saved',
    saveFailed: '{count} change failed to save | {count} changes failed to save',
    retry: 'Retry',
    sharedWarning:
      'This feature is reused by {count} other feature | This feature is reused by {count} other features. Changes affect all of them.',
    upstreamChanged:
      'This feature was changed elsewhere while you were editing. Saving now may overwrite those changes.',
    reloadFromServer: 'Reload from server',
    editingDashboard: 'Editing feature',
    noCopyTargets: 'No other dashboards',
    previewHint:
      'Show the dashboard read-only, exactly as users will see it: tiles cannot be moved or resized, tiles hidden by their hide expression stay hidden, and size-to-content / floating stay active. Off reveals every tile so the layout stays fully editable.',
    parameters: {
      title: 'Parameters',
      add: 'Add parameter',
      empty: 'No parameters',
      label: 'Label',
      name: 'Variable name',
      kind: 'Type',
      displayStyle: 'Display style',
      defaultValue: 'Default value',
      remove: 'Remove parameter',
      configuration: 'Configuration',
      currentValue: 'Current value',
      listView: 'Parameter list',
      contextView: 'Expression context',
      currentValueHint: 'Resolved runtime value. This view is read-only.',
      noCurrentValue: 'No current value has been resolved for this parameter.',
      copyCurrentValue: 'Copy current value',
      currentValueCopied: 'Current parameter value copied to clipboard'
    },
    queries: {
      title: 'Shared queries',
      add: 'Add shared query',
      empty: 'No shared queries',
      addQuery: 'Add query',
      emptyQueries: 'No queries'
    },
    deleteTileConfirm: 'Delete tile "{name}" from the draft? It will be removed when you save.',
    tile: {
      unnamed: 'Unnamed tile',
      name: 'Tile name',
      appearance: 'Appearance',
      backgroundColor: 'Background color',
      flat: 'Flat',
      bordered: 'Bordered',
      square: 'Square',
      headerFontSize: 'Header font size',
      headerAlign: 'Header alignment',
      cssClass: 'CSS class',
      layout: 'Layout',
      x: 'X',
      y: 'Y',
      width: 'Width',
      height: 'Height',
      advancedEdit: 'Edit in dialog',
      configureHint: 'Configure this tile in the right panel',
      nestedDashboards: 'Nested dashboards',
      editNestedDashboard: 'Edit this nested dashboard',
      duplicated: 'Tile duplicated'
    },
    tabs: {
      tile: 'Tile',
      dashboard: 'Feature',
      parameters: 'Parameters',
      queries: 'Queries',
      children: 'Child features',
      copilot: 'Copilot'
    },
    children: {
      empty:
        'No child features. Add features with this feature as parent, or configure tabs explicitly.'
    },
    copilot: {
      welcomeTitle: 'Feature copilot',
      welcomeSubtitle: 'Ask me to add tiles, change queries, or restyle this dashboard.',
      welcomeSubtitleTabs: 'Ask me to change tabs, the header, or the parameters of this feature.'
    },
    addTile: 'Add tile',
    tileCatalog: {
      filter: 'Filter tile types',
      noResults: 'No tiles match your search'
    }
  },
  fabricTree: {
    lakehouse: 'Lakehouse',
    folder: 'Folder',
    file: 'File',
    noItems: 'No items available'
  },
  twinMoveDialog: {
    title: 'Move {count} twin | Move {count} twins',
    subtitle: 'Manage parent-child relationships',
    removeRels: 'Remove incoming relationships',
    optional: 'optional',
    addRels: 'Add new relationships',
    newParent: 'New parent twin(s)',
    relType: 'Relationship type',
    relTypeAll: 'All relationships will be created as {name}',
    onlyOption: 'only option',
    move: 'Move',
    relIdGen: 'Relationship ID',
    relIdGenUid: 'Auto-generate (UUID)',
    relIdGenSourceTarget: 'Source-Target pattern'
  },
  profile: {
    title: 'My profile',
    description: 'Manage your contact details and how the platform notifies you.',
    contactDetails: 'Contact details',
    email: 'Email',
    phoneNumber: 'Mobile phone number',
    phoneNumberHint: 'International format, including the country code (e.g. +32470000000)',
    phoneNumberInvalid:
      'Enter your number in international format, including the country code (e.g. +32470000000)',
    smsTitle: 'SMS notifications',
    smsOptionalBadge: 'Optional',
    smsIntro:
      'Flows in the platform can send you a text message when something needs your attention. This is entirely optional: you can use the Arcadis Digital Twins platform without it, and it is not part of the terms and conditions you accepted.',
    smsConsentLabel:
      'Yes, I agree to receive SMS notifications from Arcadis Digital Twins at the phone number above.',
    smsPhoneRequired: 'Add your mobile phone number first to be able to opt in.',
    smsFrequency:
      'Message frequency: occasional alerts and notifications triggered by the flows configured for your environment. We do not send recurring marketing messages.',
    smsRates: 'Message and data rates may apply.',
    smsOptOut: 'Reply STOP to cancel at any time. Reply HELP for help.',
    smsLinks: 'How we handle your data:',
    privacyPolicy: 'Privacy Policy',
    termsAndConditions: 'Terms & Conditions',
    smsOptedInSince: 'You opted in on {date}.',
    smsNotOptedIn: 'You are not receiving SMS notifications.',
    saved: 'Your preferences have been saved.',
    saveFailed: 'Your preferences could not be saved. Please try again.',
    loadFailed: 'Your profile could not be loaded. Please try again.'
  },
  twinEditProperty: {
    smsRecipients: {
      label: 'Recipients',
      hint: 'Only users with a phone number who opted in to SMS notifications are listed',
      noRecipients: 'No user in this environment has opted in to SMS notifications yet',
      unknownRecipient: 'Unknown recipient',
      expressionInUse: 'This activity uses an expression to determine the recipients.',
      useRecipientList: 'Select users instead'
    },
    secretFields: {
      sas: 'SAS',
      username: 'Username',
      password: 'Password', // NOSONAR - This is a label, not a real password field
      clientId: 'Client ID',
      clientSecret: 'Client Secret',
      apiKey: 'API Key',
      sharedKeyName: 'Shared Key Name',
      sharedKey: 'Shared Key',
      token: 'Token',
      refreshToken: 'Refresh Token',
      authBody: 'Authentication Request Body',
      authHeaders: 'Authentication Request Headers (JSON)'
    }
  }
}
